/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_Q4Inputs */

const en_diff_faq_q4 = /** @type {(inputs: Diff_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if both JSONs are identical?`)
};

const ko_diff_faq_q4 = /** @type {(inputs: Diff_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 JSON이 동일하면 어떻게 되나요?`)
};

const ja_diff_faq_q4 = /** @type {(inputs: Diff_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`両方のJSONが同一の場合はどうなりますか？`)
};

/**
* | output |
* | --- |
* | "What if both JSONs are identical?" |
*
* @param {Diff_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_q4 = /** @type {((inputs?: Diff_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_q4(inputs)
	if (locale === "ko") return ko_diff_faq_q4(inputs)
	return ja_diff_faq_q4(inputs)
});